<template>
  <div>
    <template v-if="loading">
      <content-placeholders>
        <content-placeholders-text :lines="10"/>
      </content-placeholders>
    </template>
    <template v-else-if="items.length">
      <div class="catalog-view__box">
        <div class="catalog-view__box-head">
          <div class="catalog-view__subtitle" id="brutto">Логистические данные Брутто</div>
        </div>
        <div class="catalog-view__table catalog-view__table-brutto">
          <table>
            <thead>
            <tr>
              <th>Тип упаковки</th>
              <th>Уровень</th>
              <th>Описание</th>
              <th>Кол-во</th>
              <th>Ед. изм.</th>
              <th>Штрихкод</th>
              <th>Длина</th>
              <th>Ширина</th>
              <th>Высота</th>
              <th>Ед. изм. размера</th>
              <th>Вес</th>
              <th>Ед. изм. размера</th>
            </tr>
            </thead>
            <tbody>
            <tr :class="item.isOptimal ? 'catalog-view__tr-bold' : ''" v-for="(item, key) in items" :key="key">
              <td>
                {{ item.packingType.title }}
                <svg content="Оптимальное количество товара в упаковке относительно минимальной партии заказа" v-tippy="{ arrow : true,  animation : 'fade'}" v-if="item.isOptimal"
                     width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="7" stroke="#ADB3B1" stroke-width="2"/>
                  <line x1="12" y1="13" x2="12" y2="15" stroke="#ADB3B1" stroke-width="2" stroke-linecap="round"/>
                  <circle cx="12" cy="9" r="0.5" stroke="#ADB3B1"/>
                </svg>
              </td>
              <td data-text="Уровень"> {{ item.level }}</td>
              <td data-text="Описание">{{ item.packingType.description || '—' }}</td>
              <td data-text="Кол-во" :data-text-after="getQuantity(item.quantity_unit)">{{ item.quantity || '—' }}</td>
              <td>{{ getQuantity(item.quantity_unit) }}</td>
              <td data-text="Штрихкод">{{ item.ean || '—' }}</td>
              <td data-text="Длина" :data-text-after="getLength(item.quantity_unit)">{{ item.length || '—' }}</td>
              <td data-text="Ширина" :data-text-after="getLength(item.quantity_unit)">{{ item.width || '—' }}</td>
              <td data-text="Высота" :data-text-after="getLength(item.quantity_unit)">{{ item.height || '—' }}</td>
              <td>{{ getLength(item.size_unit) || '—' }}</td>
              <td data-text="Вес" :data-text-after="getWeight(item.quantity_unit)">{{ item.weight || '—' }}</td>
              <td>{{ getWeight(item.weight_unit) || '—' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import { getLength } from '@/common/lengthUnit'
import { getWeight } from '@/common/weightUnit'
import { getQuantity } from '@/common/quantityUnit'
import {EVENT_ADD_CHIPS} from "../../views/ProductCard";

export default {
  name: 'packing-gross',
  components: {},
  props: {
    product_id: {
      require: true
    }
  },
  data: () => ({
    items: [],
    loading: true
  }),
  created() {
    this.$api.product.packingGross(this.product_id, 'packingType').then((response) => {
      if (response && response.data) {
        this.items = response.data
        if (this.items.length) {
          this.$emit(EVENT_ADD_CHIPS, {
            link: 'brutto',
            title: 'Логистические данные Брутто',
            size: null,
            order: 8
          })
        }
      }
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {
    getQuantity,
    getWeight,
    getLength
  }
}
</script>